(() => {
  const roots = document.querySelectorAll('[data-sk-catalog]');

  roots.forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-sk-product-card]'));
    const chips = Array.from(root.querySelectorAll('[data-sk-filter]'));
    const sort = root.querySelector('[data-sk-sort]');
    const count = root.querySelector('[data-sk-count]');

    const active = {
      use: 'all',
      price: 'all',
      brand: 'all',
      sale: 'all',
    };

    const params = new URLSearchParams(window.location.search);
    ['use', 'price', 'brand', 'sale'].forEach((group) => {
      const value = params.get(group);
      if (value) active[group] = value.toLowerCase();
    });

    const numberValue = (value) => {
      const parsed = Number(String(value || '').replace(',', '.'));
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const matches = (card) => {
      const price = numberValue(card.dataset.price);
      const speed = numberValue(card.dataset.speed);
      const power = numberValue(card.dataset.power);
      const use = card.dataset.use || '';
      const tags = card.dataset.tags || '';
      const brand = (card.dataset.brand || '').toLowerCase();
      const legal = card.dataset.trafficLegal === 'true';
      const sale = card.dataset.sale === 'true';

      if (active.brand !== 'all' && brand !== active.brand && !tags.includes(active.brand)) return false;
      if (active.sale === 'true' && !sale) return false;

      if (active.price === 'under-500' && price >= 500) return false;
      if (active.price === 'under-800' && price >= 800) return false;
      if (active.price === '500-1000' && (price < 500 || price > 1000)) return false;
      if (active.price === '500-1500' && (price < 500 || price > 1500)) return false;
      if (active.price === '800-1500' && (price < 800 || price > 1500)) return false;
      if (active.price === 'over-1000' && price <= 1000) return false;
      if (active.price === 'over-1500' && price <= 1500) return false;

      if (active.use === 'legal' && !legal) return false;
      if (active.use === 'commute' && !use.includes('commute') && !tags.includes('tyomatkalle')) return false;
      if (active.use === 'power' && legal && !tags.includes('tehomalli') && !tags.includes('yksityisalue') && power < 1001 && speed < 26) return false;
      if (
        active.use !== 'all' &&
        active.use !== 'legal' &&
        active.use !== 'commute' &&
        active.use !== 'power' &&
        !use.includes(active.use) &&
        !tags.includes(active.use)
      ) return false;

      return true;
    };

    const sortCards = (visible) => {
      const mode = sort?.value || 'recommended';
      const sorted = [...visible];

      sorted.sort((a, b) => {
        if (mode === 'price-asc') return numberValue(a.dataset.price) - numberValue(b.dataset.price);
        if (mode === 'price-desc') return numberValue(b.dataset.price) - numberValue(a.dataset.price);
        if (mode === 'speed-desc') return numberValue(b.dataset.speed) - numberValue(a.dataset.speed);
        if (mode === 'range-desc') return numberValue(b.dataset.range) - numberValue(a.dataset.range);
        if (mode === 'weight-asc') return numberValue(a.dataset.weight) - numberValue(b.dataset.weight);
        return numberValue(a.dataset.index) - numberValue(b.dataset.index);
      });

      sorted.forEach((card) => card.parentElement?.appendChild(card));
    };

    const apply = () => {
      const visible = [];

      cards.forEach((card) => {
        const show = matches(card);
        card.hidden = !show;
        if (show) visible.push(card);
      });

      sortCards(visible);
      if (count) count.textContent = `${visible.length} mallia`;
    };

    chips.forEach((chip) => {
      const group = chip.dataset.skFilterGroup;
      const value = chip.dataset.skFilter || 'all';
      if (group) chip.classList.toggle('is-active', active[group] === value);

      chip.addEventListener('click', () => {
        const group = chip.dataset.skFilterGroup;
        if (!group) return;

        active[group] = chip.dataset.skFilter || 'all';
        root
          .querySelectorAll(`[data-sk-filter-group="${group}"]`)
          .forEach((item) => item.classList.toggle('is-active', item === chip));

        apply();
      });
    });

    sort?.addEventListener('change', apply);
    apply();
  });
})();
